
export const formatRelationshipType = (type: string): string => {
  switch (type) {
    case 'serious':
      return 'Relacionamento Sério';
    case 'casual_fixed':
      return 'Caso Fixo';
    case 'casual_flex':
      return 'Encontros';
    // Valores legados (manter para compatibilidade)
    case 'casual':
      return 'Relacionamentos Casuais';
    case 'friendship':
      return 'Amizade';
    default:
      return type || 'Não especificado';
  }
};

export const formatIncomeRange = (income: string): string => {
  switch (income) {
    case 'below_50k':
      return 'Até R$ 50.000';
    case '50k_100k':
      return 'R$ 50.000 - R$ 100.000';
    case '100k_200k':
      return 'R$ 100.000 - R$ 200.000';
    case '200k_500k':
      return 'R$ 200.000 - R$ 500.000';
    case '500k_1m':
      return 'R$ 500.000 - R$ 1.000.000';
    case 'above_1m':
      return 'Acima de R$ 1.000.000';
    case 'prefer_not_to_say':
      return 'Prefiro não informar';
    default:
      return income || 'Não informado';
  }
};

export const formatGender = (gender: string): string => {
  switch (gender) {
    case 'male':
      return 'Masculino';
    case 'female':
      return 'Feminino';
    case 'other':
      return 'Outro';
    default:
      return gender || 'Não especificado';
  }
};

export const formatOrientation = (orientation: string): string => {
  switch (orientation) {
    case 'straight':
      return 'Heterossexual';
    case 'gay':
      return 'Homossexual';
    case 'bisexual':
      return 'Bissexual';
    case 'other':
      return 'Outra';
    default:
      return orientation || 'Não especificado';
  }
};

export const formatCurrency = (value: number): string => {
  const formatted = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    maximumFractionDigits: 0
  }).format(value);
  
  // Substituir espaço não-quebrável (U+00A0) por espaço normal (U+0020)
  return formatted.replace(/\u00A0/g, ' ');
};
